var _path, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 84,
    viewBox: "0 0 66 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7589 84C33.7589 84 -9.95107 36.4634 2.10231 15.6272C14.1557 -5.20906 51.7782 -5.20906 63.8315 15.6272C75.8849 36.4634 33.7589 84 33.7589 84Z",
    fill: "#5472D3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 28,
    rx: 29,
    ry: 23,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0227 41V17.7273H35.2045C36.9697 17.7273 38.4735 18.0644 39.7159 18.7386C40.9583 19.4053 41.9053 20.3333 42.5568 21.5227C43.2159 22.7045 43.5455 24.0682 43.5455 25.6136C43.5455 27.1591 43.2121 28.5227 42.5455 29.7045C41.8788 30.8864 40.9129 31.8068 39.6477 32.4659C38.3902 33.125 36.8674 33.4545 35.0795 33.4545H29.2273V29.5114H34.2841C35.2311 29.5114 36.0114 29.3485 36.625 29.0227C37.2462 28.6894 37.7083 28.2311 38.0114 27.6477C38.322 27.0568 38.4773 26.3788 38.4773 25.6136C38.4773 24.8409 38.322 24.1667 38.0114 23.5909C37.7083 23.0076 37.2462 22.5568 36.625 22.2386C36.0038 21.9129 35.2159 21.75 34.2614 21.75H30.9432V41H26.0227Z",
    fill: "#0D47A1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.0bed744490886d53fa12631af2042b45.svg";
export { ForwardRef as ReactComponent };